<template>
  <div class="grants_list">
    <div class="bigLoading" v-if="!renderComp">
      <div class="sk-fading-circle">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
      </div>
    </div>
    <div class="inner" v-if="renderComp" :class="{ mapActive: openMap }">
      <div class="box">
        <div class="search-cont">
          <div class="inp-search">
            <div class="details font-16 f-roman underline">
              <p @click="active = true">
                {{ $fn.tr("Detailed") }}
                <span class=" font-16 f-roman underline">{{
                  $fn.tr("Search")
                }}</span>
              </p>
              <div
                class="clear icon"
                v-if="active || search !== ''"
                @click="clearAll"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15.27"
                  height="15.27"
                  viewBox="0 0 15.27 15.27"
                >
                  <path
                    id="Union_2"
                    data-name="Union 2"
                    d="M.736,15.207a1.365,1.365,0,0,1,0-1.93L6.042,7.972.735,2.665A1.364,1.364,0,0,1,2.664.736L7.971,6.043,13.277.736a1.365,1.365,0,0,1,1.93,1.931L9.9,7.973l5.305,5.305a1.364,1.364,0,1,1-1.929,1.929L7.972,9.9,2.666,15.207a1.365,1.365,0,0,1-1.93,0Z"
                    transform="translate(-0.336 -0.337)"
                    fill="#db504a"
                  />
                </svg>
              </div>
            </div>
            <input
              v-model="search"
              class="font-21 f-roman"
              type="text"
              :placeholder="$fn.tr('Type Keyword')"
            />
          </div>
          <slide-up-down :active="active" :duration="600">
            <div class="detail-search-cont mobile">
              <div class="select">
                <el-select
                  @click="rangeAcctive = false"
                  :placeholder="$fn.tr('Status')"
                  v-model="activeValue"
                >
                  <el-option :value="$fn.tr('Active')"> </el-option>
                  <el-option :value="$fn.tr('Completed')"> </el-option>
                </el-select>
              </div>
              <div class="select ranges" :class="{ active: rangeAcctive }">
                <div class="top-cont" @click="openRange">
                  <p>{{ $fn.tr("Range") }}</p>
                  <i
                    class="i el-select__caret el-input__icon el-icon-arrow-up"
                    :class="{ active: rangeAcctive }"
                  ></i>
                </div>
                <div class="content">
                  <el-input-number
                    size="mini"
                    v-model="range1"
                  ></el-input-number>
                  <el-input-number
                    size="mini"
                    v-model="range2"
                  ></el-input-number>
                </div>
              </div>
            </div>
          </slide-up-down>
          <div class="mobile-map-cont">
            <div class="or">{{ $fn.tr("OR") }}</div>
            <div class="mobile-select">
              <div
                class="icon clear pointer"
                v-if="currentSelect !== null"
                @click="clearSelect"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15.27"
                  height="15.27"
                  viewBox="0 0 15.27 15.27"
                >
                  <path
                    id="Union_2"
                    data-name="Union 2"
                    d="M.736,15.207a1.365,1.365,0,0,1,0-1.93L6.042,7.972.735,2.665A1.364,1.364,0,0,1,2.664.736L7.971,6.043,13.277.736a1.365,1.365,0,0,1,1.93,1.931L9.9,7.973l5.305,5.305a1.364,1.364,0,1,1-1.929,1.929L7.972,9.9,2.666,15.207a1.365,1.365,0,0,1-1.93,0Z"
                    transform="translate(-0.336 -0.337)"
                    fill="#db504a"
                  ></path>
                </svg>
              </div>
              <div class="top-cont" @click="openDrop">
                <p class="font-21 f-roman" v-if="selectText !== null">
                  {{ $fn.tr(selectText) }}
                </p>
                <p class="font-21 f-roman" v-if="realSelectText !== null">
                  {{ realSelectText }}
                </p>
                <div class="icon" :class="{ iconRotate: activeSelect }">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14.841"
                    viewBox="0 0 14 14.841"
                  >
                    <g
                      id="Group_5958"
                      data-name="Group 5958"
                      transform="translate(4906 -1593) rotate(90)"
                    >
                      <path
                        id="Icon_ionic-md-arrow-round-back"
                        data-name="Icon ionic-md-arrow-round-back"
                        d="M6.911,11.98h9.025l-3.5-3.349a1.4,1.4,0,0,1,0-1.906,1.247,1.247,0,0,1,1.822,0l5.829,5.651a1.285,1.285,0,0,1,.38.945v.017a1.285,1.285,0,0,1-.38.945l-5.824,5.651a1.247,1.247,0,0,1-1.822,0,1.4,1.4,0,0,1,0-1.906l3.5-3.349H6.916a1.32,1.32,0,0,1-1.291-1.35A1.306,1.306,0,0,1,6.911,11.98Z"
                        transform="translate(1587.375 4885.67)"
                        fill="#db504a"
                      />
                    </g>
                  </svg>
                </div>
              </div>
              <div class="content" :class="{ active: activeSelect }">
                <p
                  @click="setCategory(item)"
                  class="font-16 f-med"
                  v-for="(item, index) in getRegions"
                  :key="index"
                >
                  {{ _.get(item, "title") }}
                </p>
              </div>
            </div>
            <button @click="openMap = true">
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36.002"
                  height="41.998"
                  viewBox="0 0 36.002 41.998"
                >
                  <path
                    id="Subtraction_6"
                    data-name="Subtraction 6"
                    d="M610-2787h0l-3.685-6.171a18.037,18.037,0,0,1-10.225-6.229,18.059,18.059,0,0,1-3.006-5.283A18.14,18.14,0,0,1,592-2810.9a18.033,18.033,0,0,1,5.273-12.8A17.837,17.837,0,0,1,610-2829a17.829,17.829,0,0,1,12.726,5.3A18.035,18.035,0,0,1,628-2810.9a18.137,18.137,0,0,1-1.088,6.212,18.061,18.061,0,0,1-3.006,5.283,18.036,18.036,0,0,1-10.224,6.229L610-2787Zm0-31a7.008,7.008,0,0,0-7,7,7.008,7.008,0,0,0,7,7,7.008,7.008,0,0,0,7-7A7.008,7.008,0,0,0,610-2818Z"
                    transform="translate(-592 2829)"
                    fill="#fff"
                  />
                </svg>
              </div>
              <p class="underline font-16 f-roman">{{ $fn.tr("Map") }}</p>
            </button>
          </div>
        </div>
        <slide-up-down :active="active" :duration="600">
          <div class="detail-search-cont hide">
            <div class="select">
              <el-select
                :placeholder="$fn.tr('Status')"
                v-model="activeValue"
                @click="rangeAcctive = false"
              >
                <el-option :value="$fn.tr('Active')"> </el-option>
                <el-option :value="$fn.tr('Completed')"> </el-option>
              </el-select>
            </div>
            <div class="select ranges" :class="{ active: rangeAcctive }">
              <div class="top-cont" @click="openRange">
                <p>{{ $fn.tr("Range") }}</p>
                <i
                  class="i el-select__caret el-input__icon el-icon-arrow-up"
                  :class="{ active: rangeAcctive }"
                ></i>
              </div>
              <div class="content">
                <el-input-number size="mini" v-model="range1"></el-input-number>
                <el-input-number size="mini" v-model="range2"></el-input-number>
              </div>
            </div>
          </div>
        </slide-up-down>
        <!-- <button class="clearFilter" @click="clearFilter" v-if="activeFilter">
          {{ $fn.tr("Clear Filter") }}
        </button> -->
        <div class="top-cont">
          <p class="text font-16 f-medium">
            <span class="font-16 f-medium">
              {{ getGrants }}
            </span>
            {{ $fn.tr("Grants to") }}
            <span class="font-16 f-medium">{{ getGrantees }} </span
            >{{ $fn.tr("Grantees Totaling") }}
            <span class="font-16 f-medium">{{ getBudget }} ₾</span>
          </p>
          <download-excel :data="getECXELData" v-if="renderElem">
            <button>
              <p class="font-16 f-medium">{{ $fn.tr("Export") }}:</p>
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30.653"
                  height="29.664"
                  viewBox="0 0 30.653 29.664"
                >
                  <path
                    id="Exel"
                    d="M22.944,20v6.922H18v17.8h4.944v4.944H48.653V20Zm0,11.866h2.62L26.9,33.843l1.335-1.978h2.62l-2.62,3.955,2.62,3.955h-2.62L26.9,37.8l-1.335,1.978h-2.62l2.62-3.955ZM46.675,47.686H24.922V44.72H35.8V38.787h7.91V36.81H35.8V34.832h7.91V32.854H35.8V30.877h7.91V28.9H35.8V26.922H24.922V21.978H46.675Z"
                    transform="translate(-18 -20)"
                    fill="#57a773"
                  />
                </svg>
              </div>
            </button>
          </download-excel>
        </div>
        <div class="content hm" v-on:scroll="scrollFunction($event)">
          <transition-group name="fade" appear>
            <template v-if="renderElem">
              <listItem
                v-for="(item, index) in getData"
                :key="index"
                :item="item"
              />
            </template>
          </transition-group>
          <p class="err font-24 f-bold" v-if="!renderElem && renderNum !== 0">
            {{ $fn.tr("Not found") }}
          </p>
          <p class="err font-24 f-bold" v-if="!renderElem && renderNum === 0">
            {{ $fn.tr("Loading...") }}
          </p>
        </div>
        <div
          @click="showAll"
          class="arrwIcon"
          :class="{
            active:
              defShow < _.get(contentData, 'data.listCount') &&
              enableSlice &&
              !laoded
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14.841"
            viewBox="0 0 14 14.841"
          >
            <g
              id="Group_5958"
              data-name="Group 5958"
              transform="translate(4906 -1593) rotate(90)"
            >
              <path
                id="Icon_ionic-md-arrow-round-back"
                data-name="Icon ionic-md-arrow-round-back"
                d="M6.911,11.98h9.025l-3.5-3.349a1.4,1.4,0,0,1,0-1.906,1.247,1.247,0,0,1,1.822,0l5.829,5.651a1.285,1.285,0,0,1,.38.945v.017a1.285,1.285,0,0,1-.38.945l-5.824,5.651a1.247,1.247,0,0,1-1.822,0,1.4,1.4,0,0,1,0-1.906l3.5-3.349H6.916a1.32,1.32,0,0,1-1.291-1.35A1.306,1.306,0,0,1,6.911,11.98Z"
                transform="translate(1587.375 4885.67)"
                fill="#db504a"
              ></path>
            </g>
          </svg>
        </div>
        <br />
        <br />
        <transition name="fade">
          <p class="loaded" :class="{ active: laoded }">
            {{ $fn.tr("+50 data loaded") }}
          </p>
        </transition>
      </div>
      <div class="box">
        <div class="regionFilter">
          <div
            class="icon clear pointer"
            v-if="currentSelect !== null"
            @click="clearSelect"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15.27"
              height="15.27"
              viewBox="0 0 15.27 15.27"
            >
              <path
                id="Union_2"
                data-name="Union 2"
                d="M.736,15.207a1.365,1.365,0,0,1,0-1.93L6.042,7.972.735,2.665A1.364,1.364,0,0,1,2.664.736L7.971,6.043,13.277.736a1.365,1.365,0,0,1,1.93,1.931L9.9,7.973l5.305,5.305a1.364,1.364,0,1,1-1.929,1.929L7.972,9.9,2.666,15.207a1.365,1.365,0,0,1-1.93,0Z"
                transform="translate(-0.336 -0.337)"
                fill="#db504a"
              ></path>
            </svg>
          </div>
          <div class="or font-21 f-light">{{ $fn.tr("OR") }}</div>
          <div class="select">
            <div class="top-cont" @click="openDrop">
              <p class="font-21 f-roman" v-if="selectText !== null">
                {{ $fn.tr(selectText) }}
              </p>
              <p class="font-21 f-roman" v-if="realSelectText !== null">
                {{ realSelectText }}
              </p>
              <div class="icon" :class="{ iconRotate: activeSelect }">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14.841"
                  viewBox="0 0 14 14.841"
                >
                  <g
                    id="Group_5958"
                    data-name="Group 5958"
                    transform="translate(4906 -1593) rotate(90)"
                  >
                    <path
                      id="Icon_ionic-md-arrow-round-back"
                      data-name="Icon ionic-md-arrow-round-back"
                      d="M6.911,11.98h9.025l-3.5-3.349a1.4,1.4,0,0,1,0-1.906,1.247,1.247,0,0,1,1.822,0l5.829,5.651a1.285,1.285,0,0,1,.38.945v.017a1.285,1.285,0,0,1-.38.945l-5.824,5.651a1.247,1.247,0,0,1-1.822,0,1.4,1.4,0,0,1,0-1.906l3.5-3.349H6.916a1.32,1.32,0,0,1-1.291-1.35A1.306,1.306,0,0,1,6.911,11.98Z"
                      transform="translate(1587.375 4885.67)"
                      fill="#db504a"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div class="content" :class="{ active: activeSelect }">
              <p
                @click="setCategory(item)"
                class="font-16 f-med"
                v-for="(item, index) in getRegions"
                :key="index"
              >
                {{ _.get(item, "title") }}
              </p>
            </div>
          </div>
        </div>
        <button class="closeMap" @click="openMap = false">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27.55"
            height="27.549"
            viewBox="0 0 27.55 27.549"
          >
            <path
              id="Union_2"
              data-name="Union 2"
              d="M1.431,27.2l-.607-.608a2,2,0,0,1,0-2.829l9.751-9.752L.822,4.258a2,2,0,0,1,0-2.829L1.428.823a2,2,0,0,1,2.829,0l9.753,9.753L23.764.823a2,2,0,0,1,2.828,0l.608.608a2,2,0,0,1,0,2.829l-9.753,9.753,9.75,9.75a2,2,0,0,1,0,2.829l-.607.607a2,2,0,0,1-2.829,0l-9.75-9.75L4.26,27.2a2,2,0,0,1-2.829,0Z"
              transform="translate(-0.236 -0.237)"
              fill="#fff"
            />
          </svg>
        </button>
        <GmapMap
          :center="center"
          :zoom="zoomData"
          ref="mapRef"
          :options="{
            styles: darkTheme,
            zoomControl: true,
            gestureHandling: 'cooperative'
          }"
        >
          <GmapMarker
            v-for="(item, index) in _.get(getINDX, 'region')"
            :key="index"
            :clickable="true"
            :icon="marker"
            @click="setMarker(item)"
            :position="{
              lat: parseFloat(_.get(item, 'map.lat')),
              lng: parseFloat(_.get(item, 'map.lon'))
            }"
          >
          </GmapMarker>
        </GmapMap>
      </div>
    </div>
  </div>
</template>

<script>
import listItem from "../list/grant_list_item.vue";
export default {
  components: {
    listItem
  },
  props: ["contentData"],
  data() {
    // const _this = this;
    return {
      innerFIltred: false,
      renderComp: false,
      search: "",
      active: false,
      activeSelect: false,
      openMap: false,
      selectText: "Sort by Municipality",
      realSelectText: null,
      activeTags: [],
      currentSelect: null,
      loadedElem: false,
      zoomData: 9,
      projectID: null,
      activeValue: null,
      range1: 0,
      range2: 0,
      rangeAcctive: false,
      activeFilter: false,
      filtredTags: [],
      tagInteractive: false,
      defShow: 0,
      FullBalance: 0,
      toGrants: 0,
      filtredData: [],
      filtredData2: [],
      filtredEvent: false,
      renderElem: false,
      renderNum: 0,
      params: {},
      laoded: false,
      enableSlice: true,

      marker: require("@/assets/img/marker.png"),
      darkTheme: [
        { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
        {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [{ color: "#d59563" }]
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{ color: "#d59563" }]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#263c3f" }]
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{ color: "#6b9a76" }]
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#38414e" }]
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [{ color: "#212a37" }]
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9ca5b3" }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#746855" }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#1f2835" }]
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [{ color: "#f3d19c" }]
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#2f3948" }]
        },
        {
          featureType: "transit.station",
          elementType: "labels.text.fill",
          stylers: [{ color: "#d59563" }]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#17263c" }]
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{ color: "#515c6d" }]
        },
        {
          featureType: "water",
          elementType: "labels.text.stroke",
          stylers: [{ color: "#17263c" }]
        }
      ],

      center: { lat: 41.716667, lng: 44.783333 },

      swiperOptions: {
        watchOverflow: true,
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 10,
        speed: 1000,
        breakpoints: {}
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("click", () => {
        this.activeSelect = false;
      });

      setTimeout(() => {
        this.sliceData();
        this.renderComp = true;
      }, 3000);
    });
  },
  computed: {
    getBudget() {
      return new Intl.NumberFormat().format(
        _.get(this.$store.state.main.indx, "live_statistics.budget")
      );
    },
    getGrants() {
      return new Intl.NumberFormat().format(
        _.get(this.$store.state.main.indx, "live_statistics.grants")
      );
    },
    getGrantees() {
      return new Intl.NumberFormat().format(
        _.get(this.$store.state.main.indx, "live_statistics.grantees")
      );
    },
    sendData() {
      this.params = {
        regionID: _.get(this.currentSelect, "id"),
        searchWord: this.search,
        projectID: this.projectID,
        status: this.activeValue,
        range1: this.range1,
        range2: this.range2
      };
      if (this.params.searchWord === "") {
        this.params.searchWord = null;
      }
      if (
        this.params.searchWord === null &&
        this.params.regionID === undefined &&
        this.params.status === null &&
        this.params.range2 === 0
      ) {
        return _.get(this.contentData, "data.list");
      }
      return _.get(this.contentData, "data.list").filter(
        el =>
          _.includes(_.get(el, "region"), this.params.regionID) ||
          _.get(el, "grantee_oganization")
            .toLowerCase()
            .includes(
              this.params.searchWord !== null
                ? this.params.searchWord.toLowerCase()
                : null
            ) ||
          this.$fn.tr(_.get(el, "status")) === this.params.status ||
          (this.params.range1 <= parseInt(_.get(el, "budget")) &&
            this.params.range2 >= parseInt(_.get(el, "budget")))
      );
    },
    getRegions() {
      return _.reverse(
        _.orderBy(
          _.get(this.getINDX, "region"),
          [user => user.title.toLowerCase()],
          ["desc"]
        )
      );
    },
    getData() {
      if (this.filtredData.length > 0) {
        return this.filtredData;
      } else {
        return _.get(this.contentData, "data.list");
      }
    },
    getECXELData() {
      var data = _.get(this.contentData, "data.list");
      // if (this.defShow > 50) {
      //   data = [...this.getData];
      // } else [(data = [..._.get(this.contentData, "data.list")])];
      var res = [];

      data.forEach(item => {
        res.push({
          Grantee_Organization: _.get(item, "grantee_oganization"),
          Project_title: _.get(item, "title"),
          Project_ID: _.get(item, "id"),
          status: _.get(item, "status"),
          Project_Duration: `${_.get(item, "project_duration")}/${_.get(
            item,
            "project_duration_to"
          )}`,
          Budget: `${_.get(item, "budget")} GEL`,
          Geogtaphy: _.get(item, "geography"),
          Area_of_Work: _.get(item, "area_of_work"),
          Number_of_Beneficiares: _.get(item, "number_of_beneficiares"),
          Publication_Statement: _.get(item, "publication_statement")
        });
      });
      return res;
    },
    getINDX() {
      return _.get(this.$store, "state.main.indx.terms");
    }
  },
  watch: {
    filtredData: {
      immediate: true,
      handler: function() {
        if (this.filtredData.length !== 0) {
          this.renderElem = true;
          this.renderNum++;
        } else if (
          this.filtredData.length === 0 &&
          this.filtredData2.length > 0
        ) {
          this.filtredData = this.filtredData2;
        }
      }
    },
    params: {
      immediate: true,
      handler: function() {
        if (
          this.params.projectID === null &&
          this.params.regionID === undefined &&
          this.params.searchWord === null &&
          this.params.status === null
        ) {
          this.renderElem = true;
        }
      }
    },
    range2: function() {
      this.enableSlice = false;
      if (this.sendData.length === 0) {
        this.renderElem = false;
      } else {
        this.renderElem = false;
      }
      if (this.params.regionID !== undefined) {
        this.filtredData = this.filtredData2.filter(
          el =>
            this.params.range1 <= parseInt(_.get(el, "budget")) &&
            this.params.range2 >= parseInt(_.get(el, "budget"))
        );
      } else {
        this.filtredData2 = [];
        this.filtredData = this.sendData;
      }
    },
    search: function() {
      this.enableSlice = false;
      if (this.sendData.length === 0) {
        this.renderElem = false;
      } else {
        this.renderElem = true;
      }
      this.filtredData = this.sendData;
    },
    activeValue: function() {
      this.enableSlice = false;
      if (this.sendData.length === 0) {
        this.renderElem = false;
      } else {
        this.renderElem = true;
      }
      if (this.params.regionID !== undefined) {
        this.filtredData = this.filtredData2.filter(
          el => this.$fn.tr(_.get(el, "status")) === this.params.status
        );
      } else {
        this.filtredData2 = [];
        this.filtredData = this.sendData;
      }
    }
  },
  methods: {
    showAll() {
      if (this.defShow <= _.get(this.contentData, "data.listCount"))
        this.laoded = true;
      this.sliceData();
      setTimeout(() => {
        this.laoded = false;
      }, 1000);
    },
    scrollFunction(e) {
      var elem = e.currentTarget;
      // console.log(
      //   elem.scrollHeight - elem.scrollTop,
      //   document.querySelector(".grants_list .hm").offsetHeight
      // );
      if (
        elem.scrollHeight - elem.scrollTop <=
        document.querySelector(".grants_list .hm").offsetHeight
      ) {
        if (this.enableSlice) {
          this.showAll();
          // console.log("show");
        }
      }
    },
    sliceData() {
      this.defShow += 50;
      this.filtredData = _.get(this.contentData, "data.list").slice(
        0,
        this.defShow
      );
    },
    openRange(e) {
      e.stopPropagation();
      this.rangeAcctive = !this.rangeAcctive;
    },
    clearAll() {
      this.range1 = 0;
      this.range2 = 0;
      this.enableSlice = true;
      this.active = false;
      this.search = "";
      this.activeValue = null;
      this.rangeAcctive = false;
      this.innerFIltred = false;
      this.filtredData = this.sendData;
      if (this.params.regionID === undefined) {
        this.defShow = 0;
        this.sliceData();
      }
    },
    clearSelect() {
      this.enableSlice = true;
      this.currentSelect = null;
      this.activeSelect = false;
      this.innerFIltred = false;
      this.selectText = "Sort by Municipality";
      this.center.lat = 41.716667;
      this.center.lng = 44.783333;
      this.realSelectText = null;
      this.zoomData = 9;
      this.filtredData2 = [];
      if (this.sendData.length === 0) {
        this.renderElem = false;
      } else {
        this.renderElem = true;
      }
      this.filtredData = this.sendData;
      this.defShow = 0;
      this.sliceData();
    },
    setMarker(val) {
      this.selectText = null;
      this.realSelectText = _.get(val, "title");
      this.currentSelect = val;
      this.center.lat = parseFloat(_.get(val, "map.lat"));
      this.center.lng = parseFloat(_.get(val, "map.lon"));
      this.zoomData = 15;
      if (this.sendData.length === 0) {
        this.renderElem = false;
      } else {
        this.renderElem = true;
      }
      this.filtredData = _.orderBy(this.sendData, "region.length", "asc");
      this.filtredData2 = _.orderBy(this.sendData, "region.length", "asc");
    },
    setTag(id) {
      if (_.includes(this.activeTags, id)) {
        if (this.activeTags.length === 1) {
          this.tagInteractive = false;
        }
        const i = this.activeTags.indexOf(id);
        if (i > -1) {
          this.activeTags.splice(i, 1);
          this.filtredTags = _.get(this.contentData, "data.list").filter(val =>
            this.activeTags.includes(_.get(val, "tags.0"))
          );
        }
      } else {
        this.tagInteractive = true;
        this.activeTags.push(id);
        this.filtredTags = _.get(this.contentData, "data.list").filter(val =>
          this.activeTags.includes(_.get(val, "tags.0"))
        );
      }
    },
    openDrop(e) {
      e.stopPropagation();
      this.activeSelect = !this.activeSelect;
    },
    clearSearch() {
      this.search = "";
    },
    setCategory(val) {
      this.enableSlice = false;
      this.zoomData = 15;
      this.center.lat = parseFloat(_.get(val, "map.lat"));
      this.center.lng = parseFloat(_.get(val, "map.lon"));
      this.selectText = null;
      this.realSelectText = _.get(val, "title");
      this.currentSelect = val;
      this.activeSelect = false;
      if (this.length === 0) {
        this.renderElem = false;
      } else {
        this.renderElem = true;
      }
      this.filtredData = _.orderBy(this.sendData, "region.length", "asc");
      this.filtredData2 = _.orderBy(this.sendData, "region.length", "asc");
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss">
body {
  &.white {
    .inner .box:first-child .inp-search,
    .inner .box:first-child .mobile-map-cont .mobile-select .top-cont,
    .inner .box:first-child .mobile-map-cont .mobile-select .content {
      border: 1px solid #3a60a9;
    }
    .inner .box:first-child .inp-search input,
    .inner .box:last-child .regionFilter .top-cont p,
    .inner .box:first-child .mobile-map-cont .mobile-select .content p,
    .inner .box:first-child .mobile-map-cont .mobile-select .top-cont p {
      color: var(--lightGray-txt);
    }
    .el-input__inner,
    .select.ranges {
      background-color: var(--thirdy-tranparent) !important;
    }
  }
  &.yellow {
    .inner .box:first-child .inp-search,
    .inner .box:first-child .mobile-map-cont .mobile-select .top-cont,
    .inner .box:first-child .mobile-map-cont .mobile-select .content {
      border: 1px solid black;
    }
    .inner .box:last-child .regionFilter .content p,
    .inner .box:first-child .mobile-map-cont .mobile-select .content p {
      color: black;
    }
    .inner .box:first-child .inp-search input,
    .inner .box:last-child .regionFilter .top-cont p,
    .inner .box:first-child .mobile-map-cont .mobile-select .top-cont p {
      color: var(--lightGray-txt);
    }
    .el-input__inner,
    .select.ranges {
      background-color: var(--thirdy-tranparent) !important;
    }
  }
  &.black {
    .inner .box:first-child .inp-search,
    .inner .box:first-child .mobile-map-cont .mobile-select .top-cont,
    .inner .box:first-child .mobile-map-cont .mobile-select .content {
      border: 1px solid yellow;
    }
    .inner .box:last-child .regionFilter .content p,
    .inner .box:first-child .mobile-map-cont .mobile-select .content p {
      color: white;
    }
    .inner .box:first-child .inp-search input,
    .inner .box:last-child .regionFilter .top-cont p,
    .inner .box:first-child .mobile-map-cont .mobile-select .top-cont p {
      color: var(--lightGray-txt);
    }
    .el-input__inner,
    .select.ranges {
      background-color: var(--thirdy-tranparent) !important;
    }
  }
}
.grants_list {
  @-webkit-keyframes sk-circleFadeDelay {
    0%,
    39%,
    100% {
      opacity: 0;
    }

    40% {
      opacity: 1;
    }
  }

  @keyframes sk-circleFadeDelay {
    0%,
    39%,
    100% {
      opacity: 0;
    }

    40% {
      opacity: 1;
    }
  }
  .bigLoading {
    padding-top: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .sk-fading-circle {
      width: 60px;
      height: 60px;
      position: relative;
    }

    .sk-fading-circle .sk-circle {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    .sk-fading-circle .sk-circle:before {
      content: "";
      display: block;
      margin: 0 auto;
      width: 15%;
      height: 15%;
      background-color: #333;
      border-radius: 100%;
      -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
      animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
    }

    .sk-fading-circle .sk-circle2 {
      -webkit-transform: rotate(30deg);
      -ms-transform: rotate(30deg);
      transform: rotate(30deg);
    }

    .sk-fading-circle .sk-circle3 {
      -webkit-transform: rotate(60deg);
      -ms-transform: rotate(60deg);
      transform: rotate(60deg);
    }

    .sk-fading-circle .sk-circle4 {
      -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);
    }

    .sk-fading-circle .sk-circle5 {
      -webkit-transform: rotate(120deg);
      -ms-transform: rotate(120deg);
      transform: rotate(120deg);
    }

    .sk-fading-circle .sk-circle6 {
      -webkit-transform: rotate(150deg);
      -ms-transform: rotate(150deg);
      transform: rotate(150deg);
    }

    .sk-fading-circle .sk-circle7 {
      -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: rotate(180deg);
    }

    .sk-fading-circle .sk-circle8 {
      -webkit-transform: rotate(210deg);
      -ms-transform: rotate(210deg);
      transform: rotate(210deg);
    }

    .sk-fading-circle .sk-circle9 {
      -webkit-transform: rotate(240deg);
      -ms-transform: rotate(240deg);
      transform: rotate(240deg);
    }

    .sk-fading-circle .sk-circle10 {
      -webkit-transform: rotate(270deg);
      -ms-transform: rotate(270deg);
      transform: rotate(270deg);
    }

    .sk-fading-circle .sk-circle11 {
      -webkit-transform: rotate(300deg);
      -ms-transform: rotate(300deg);
      transform: rotate(300deg);
    }

    .sk-fading-circle .sk-circle12 {
      -webkit-transform: rotate(330deg);
      -ms-transform: rotate(330deg);
      transform: rotate(330deg);
    }

    .sk-fading-circle .sk-circle2:before {
      -webkit-animation-delay: -1.1s;
      animation-delay: -1.1s;
    }

    .sk-fading-circle .sk-circle3:before {
      -webkit-animation-delay: -1s;
      animation-delay: -1s;
    }

    .sk-fading-circle .sk-circle4:before {
      -webkit-animation-delay: -0.9s;
      animation-delay: -0.9s;
    }

    .sk-fading-circle .sk-circle5:before {
      -webkit-animation-delay: -0.8s;
      animation-delay: -0.8s;
    }

    .sk-fading-circle .sk-circle6:before {
      -webkit-animation-delay: -0.7s;
      animation-delay: -0.7s;
    }

    .sk-fading-circle .sk-circle7:before {
      -webkit-animation-delay: -0.6s;
      animation-delay: -0.6s;
    }

    .sk-fading-circle .sk-circle8:before {
      -webkit-animation-delay: -0.5s;
      animation-delay: -0.5s;
    }

    .sk-fading-circle .sk-circle9:before {
      -webkit-animation-delay: -0.4s;
      animation-delay: -0.4s;
    }

    .sk-fading-circle .sk-circle10:before {
      -webkit-animation-delay: -0.3s;
      animation-delay: -0.3s;
    }

    .sk-fading-circle .sk-circle11:before {
      -webkit-animation-delay: -0.2s;
      animation-delay: -0.2s;
    }

    .sk-fading-circle .sk-circle12:before {
      -webkit-animation-delay: -0.1s;
      animation-delay: -0.1s;
    }
  }
  .icon {
    transition: 0.6s !important;
  }
  .content::-webkit-scrollbar {
    width: 5px;
  }

  .content::-webkit-scrollbar-track {
    background-color: #dfdfdf;
    width: 2px;
  }

  .content::-webkit-scrollbar-thumb {
    border-radius: 50px;
    background-color: #57a773;
  }

  .content::-moz-scrollbar {
    width: 5px;
  }

  .content::-moz-scrollbar-track {
    background-color: #dfdfdf;
    width: 2px;
  }

  .content::-moz-scrollbar-thumb {
    border-radius: 50px;
    background-color: #57a773;
  }

  .content::-o-scrollbar {
    width: 5px;
  }

  .content::-o-scrollbar-track {
    background-color: #dfdfdf;
    width: 2px;
  }

  .content::-o-scrollbar-thumb {
    border-radius: 50px;
    background-color: #57a773;
  }

  .content::-ms-scrollbar {
    width: 5px;
  }

  .content::-ms-scrollbar-track {
    background-color: #dfdfdf;
    width: 2px;
  }

  .content::-ms-scrollbar-thumb {
    border-radius: 50px;
    background-color: #57a773;
  }
  .err {
    text-align: center;
  }
  .clearFilter {
    margin-top: 20px;
    background: none;
    border: none;
    outline: none;
    color: red;
    cursor: pointer;
  }
  .iconRotate {
    transform: rotate(180deg);
  }
  height: 914px;
  background: var(--thirdy-tranparent);
  @media (max-width: 767px) {
    height: unset;
  }
  .inner {
    display: flex;
    height: 100%;
    &.mapActive {
      .box:first-child {
        width: 0px;
        padding: 0px;
        opacity: 0;
      }
      .box:last-child {
        width: 100%;
        opacity: 1;
        @media (max-width: 767px) {
          position: fixed;
          top: 0;
          left: 0;
          height: 100%;
          z-index: 99999999;
        }
      }
    }
    .box {
      width: 50%;
      overflow: hidden;
      transition: 0.6s;
      &:first-child {
        .loaded {
          color: green;
          display: inline-flex;
          float: right;
          transition: 0.6s;
          opacity: 0;
          &.active {
            opacity: 1;
          }
        }
        .arrwIcon {
          path {
            fill: green;
          }
          display: inline-flex;
          float: right;
          width: 30px;
          height: 30px;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-right: 20px;
          animation-duration: 2s;
          animation-name: anim;
          animation-iteration-count: infinite;
          opacity: 0;
          pointer-events: none;
          &.active {
            opacity: 1;
            pointer-events: all;
          }
          @keyframes anim {
            0% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
            100% {
              transform: translateY(0px);
            }
          }
        }
        opacity: 1;
        .mobile-map-cont {
          position: relative;
          display: none;
          width: 230px;
          .mobile-select {
            .clear {
              right: 55px;
              top: 50%;
              position: absolute;
              transform: translateY(-50%);
              right: 60px;
            }
            .content {
              position: absolute;
              top: 20px;
              left: 0;
              width: calc(100%);
              opacity: 0;
              transform: translateY(-10px);
              pointer-events: none;
              transition: 0.6s;
              background-color: #ffffff;
              border-top: 2px solid #ababab;
              z-index: 99;
              padding-bottom: 20px;
              max-height: 300px;
              overflow: auto;
              background: var(--white-bg);
              &.active {
                opacity: 1;
                transform: translateY(0px);
                pointer-events: all;
              }
              p {
                margin-top: 10px;
                cursor: pointer;
                width: 100%;
                padding-left: 43px;
                padding-right: 43px;
                padding-top: 10px;
                padding-bottom: 10px;
                transition: 0.6s;
                @media (min-width: 1024px) {
                  &:hover {
                    background-color: #e3b505;
                    color: white;
                  }
                }
              }
            }
            .top-cont {
              padding-left: 26px;
              padding-right: 26px;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-top: 0px;
              padding-bottom: 0px;
              margin-top: 0px;
              flex-direction: row;
              cursor: pointer;
              border: none;
              background: var(--white-bg);
              @media (max-width: 1679px) {
                padding-left: 33px;
                padding-right: 33px;
              }
              p {
                color: #ababab;
                user-select: none;
                font-size: 16px;
                opacity: 0.5;
              }
            }
            display: none;
            position: relative;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
            background-color: white;
            width: 100%;
            @media (max-width: 767px) {
              display: flex;
              height: 60px;
              margin-bottom: 20px;
              width: 100%;
            }
          }
          .or {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            flex: none;
            color: var(--bonus-txt);
            @media (max-width: 767px) {
              display: none;
            }
          }
          button {
            width: 100%;
            background-color: #57a773;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            @media (max-width: 767px) {
              height: 60px;
            }
            p {
              color: white;
            }
            .icon {
              margin-right: 14px;
            }
          }
          @media (max-width: 1365px) {
            display: flex;
          }
          @media (max-width: 767px) {
            flex-direction: column;
            width: 100%;
            margin-top: 20px;
          }
        }
        .search-cont {
          display: flex;
          height: 80px;
          @media (max-width: 1023px) {
            height: 60px;
          }
          @media (max-width: 767px) {
            flex-direction: column;
            height: unset;
          }
        }
        padding: 41px 37.5px 2px 30px;
        @media (max-width: 1365px) {
          width: 100%;
        }
        @media (max-width: 767px) {
          padding-left: 20px;
          padding-right: 20px;
        }
        .content {
          margin-top: 40px;
          height: calc(100% - 330px);
          overflow: auto;
          overflow-x: hidden;
          @media (max-width: 767px) {
            // height: unset;
            // overflow: unset;
            height: 600px;
          }
          .item {
            border-bottom: 1px solid #c8c9ca;
            margin-bottom: 33px;
            padding-bottom: 30px;
            padding-right: 20px;
            @media (max-width: 767px) {
              padding-right: 0px;
            }
            .ttl {
              color: var(--bonus-txt);
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
            .desc {
              color: var(--bonus-txt);
              margin-top: 19px;
              @media (max-width: 767px) {
                margin-top: 16px;
              }
              span {
                color: var(--primary-txt);
              }
            }
            .data-cont {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 13px;
              width: 100%;
              .inner-item {
                display: flex;
                align-items: center;
                margin-right: 20px;
                @media (max-width: 767px) {
                  margin-right: 0px;
                }
              }
              @media (max-width: 1679px) {
                flex-wrap: wrap;
                align-items: flex-start;
                // width: 335px;
              }
              // @media (max-width: 1365px) {
              //   width: 400px;
              // }
              // @media (max-width: 767px) {
              //   width: 100%;
              // }
              // @media (max-width: 374px) {
              //   width: 100%;
              // }
              .status {
                span.active {
                  color: #57a773;
                }
              }
              .budget {
                margin-right: 34px;
                @media (max-width: 767px) {
                  margin-right: 20px;
                }
              }
              .budget,
              .status,
              .duration {
                &.active {
                  color: #57a773;
                  span {
                    color: #57a773;
                  }
                }
                border-left: 2px solid var(--red);
                padding-left: 12px;
                // width: calc(33.33% - 50px);
                color: var(--primary-txt);
                @media (max-width: 1679px) {
                  margin-top: 13px;
                }
                @media (max-width: 767px) {
                  // white-space: nowrap;
                  // width: 100%;
                }
                @media (max-width: 374px) {
                  white-space: unset;
                }
                span {
                  color: var(--bonus-txt);
                }
              }
            }
          }
        }
        .more {
          margin-bottom: 20px !important;
          cursor: pointer;
          display: none !important;
          margin: 0 auto;
          @include defBut(
            var(--primay-button-bg),
            var(--bonus-txt3),
            var(--secondarty-transparent),
            var(--white-button-txt2)
          );
          .icon {
            margin-left: 10px;
          }
          @media (max-width: 767px) {
            display: flex !important;
          }
        }
        .top-cont {
          padding-top: 19px;
          padding-bottom: 10px;
          margin-top: 48px;
          @media (max-width: 767px) {
            flex-direction: column;
            align-items: flex-start;
          }
          .text {
            padding-right: 20px;
            color: var(--bonus-txt);
            @media (max-width: 767px) {
              margin-bottom: 20px;
            }
            span {
              color: var(--primary-txt);
            }
          }
          button {
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            background: none;
            .icon {
              margin-left: 10px;
            }
            p {
              color: var(--bonus-txt);
              text-align: left;
            }
          }
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #c8c9ca;
          border-bottom: 1px solid #c8c9ca;
        }
        .tag-cont {
          margin-top: 65px;
          display: flex;
          align-items: center;
          @media (max-width: 1365px) {
            margin-top: 34px;
          }
          .lb {
            color: var(--bonus-txt);
            margin-right: 20px;
          }
          .tags {
            display: flex;
            width: 100%;
            .swiper-container {
              width: 100%;
              .swiper-slide {
                width: auto;
              }
            }
            .tag {
              background-color: #dfdfdf;
              border-radius: 17px;
              display: flex;
              align-items: center;
              padding-left: 16px;
              padding-right: 16px;
              padding-top: 10px;
              padding-bottom: 10px;
              cursor: pointer;
              margin-right: 10px;
              p {
                color: #0d1317;
              }
              &.active {
                background-color: #57a773;
                p {
                  color: white;
                }
              }
              .icon {
                margin-left: 15px;
              }
              &:last-child {
                margin-right: 0px;
              }
            }
          }
        }
        .detail-search-cont {
          &.mobile {
            display: none;
          }
          padding-top: 20px;
          display: flex;
          @media (max-width: 1023px) {
            flex-direction: column;
          }
          @media (max-width: 767px) {
            &.hide {
              display: none;
            }
            &.mobile {
              display: block;
            }
          }
          .inp,
          .select {
            .el-icon-arrow-up:before {
              color: var(--bonus-txt);
            }
            margin-right: 30px;
            position: relative;
            width: 165px;
            cursor: pointer;
            &.ranges {
              .i {
                height: unset;
                line-height: unset;
                transform: rotate(180deg);
                transition: 0.6s;
                position: absolute;
                right: 4px;
                font-size: 14px;
                &.active {
                  transform: rotate(0deg);
                }
              }
              input {
                background: none;
              }
              .el-input__inner {
                font-size: 12px;
                color: var(--bonus-txt);
              }
              background-color: #dfdfdf;
              border: 1px solid #dcdfe6;
              border-radius: 4px;
              padding-left: 15px;
              padding-right: 15px;
              .content {
                visibility: hidden;
                opacity: 0;
                position: absolute;
                width: 100%;
                max-height: 0px;
                padding: 0ox;
                height: unset;
                background: var(--white-bg);
                left: 0;
                top: 0;
                box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
                transform: translateY(-10px);
                z-index: 99999;
                .el-input-number--mini {
                  width: 100%;
                  margin-top: 10px;
                }
              }
              &.active {
                .content {
                  opacity: 1;
                  height: unset;
                  max-height: 300px;
                  visibility: visible;
                  padding: 10px;
                  transform: translateY(0px);
                }
              }
              .top-cont {
                border: none;
                margin-top: 0px;
                padding: 0px;
                padding-top: 10px;
                p {
                  font-size: 16px;
                  color: var(--bonus-txt);
                  @media (max-width: 1023px) {
                    font-size: 14px;
                  }
                }
                @media (max-width: 767px) {
                  flex-direction: row;
                }
              }
            }
            .el-select {
              width: 100%;
              input {
                &::placeholder {
                  color: var(--bonus-txt);
                }
              }
            }
            @media (max-width: 1679px) {
              margin-right: 10px;
            }
            @media (max-width: 1023px) {
              height: 40px;
              margin-bottom: 10px;
              width: 100%;
            }
          }
          .select {
            .el-input__inner {
              background-color: #dfdfdf;
              font-size: 16px;
              @media (max-width: 1023px) {
                font-size: 14px;
              }
            }
            input::placeholder {
              color: #0d1317;
            }
          }
          .inp {
            input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: none;
              padding-left: 15px;
              padding-right: 15px;
              background-color: #dfdfdf;
              border-radius: 6px;
              border: 1px solid transparent;
              color: #0d1317;
              @media (max-width: 1023px) {
                font-size: 14px;
              }
              &::placeholder {
                color: #0d1317;
              }
              &:focus {
                background: white;
                border: 1px solid #3a60a9;
              }
            }
          }
          .inp {
            &:last-child {
              margin-right: 0px;
            }
          }
        }
        padding-right: 30px;
        .inp-search {
          position: relative;
          width: 100%;
          background: var(--white-bg);
          box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
          @media (max-width: 1365px) {
            width: calc(100% - 125px);
          }
          @media (max-width: 767px) {
            width: 100%;
            height: 60px;
          }
          .details {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 10px;
            cursor: pointer;
            color: var(--bonus-txt);
            display: flex;
            span {
              @media (max-width: 767px) {
                display: none;
              }
            }
            .icon {
              margin-left: 15px;
            }
          }
          &::after {
            content: "";
            position: absolute;
            left: 32px;
            top: 50%;
            transform: translateY(-50%);
            width: 2px;
            height: 25px;
            border-radius: 5px;
            background: var(--red);
          }
          input {
            position: absolute;
            top: 0;
            left: 56px;
            right: 56px;
            width: calc(100% - 235px);
            height: 100%;
            color: var(--bonus-txt);
            font-size: 21px;
            background: var(--white-bg);
            &::placeholder {
              opacity: 0.5;
              color: var(--bonus-txt);
            }
            @media (max-width: 1023px) {
              font-size: 16px;
            }
            @media (max-width: 767px) {
              width: calc(100% - 185px);
            }
          }
        }
      }
      &:last-child {
        // transition: none;
        div {
          transition: none;
        }
        position: relative;
        .closeMap {
          display: none;
          path {
            fill: white !important;
          }
          @media (max-width: 1365px) {
            display: flex;
            position: absolute;
            bottom: 0;
            z-index: 3;
            width: 80px;
            cursor: pointer;
            height: 80px;
            display: flex;
            background: var(--red);
            left: 50%;
            transform: translateX(-50%);
            justify-content: center;
            align-items: center;
          }
        }
        @media (max-width: 1365px) {
          width: 0px;
          opacity: 0;
        }
        .regionFilter {
          .clear {
            z-index: 3;
            position: absolute;
            right: 50px;
            top: 50%;
            transform: translateY(-50%);
          }
          position: absolute;
          top: 40px;
          left: 0;
          z-index: 9;
          display: flex;
          height: 80px;
          width: calc(100% - 160px);
          @media (max-width: 1679px) {
            width: calc(100% - 34px);
          }
          @media (max-width: 767px) {
            left: 50%;
            transform: translateX(-50%);
            width: calc(100% - 20px);
          }
          .select {
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
            background-color: white;
            width: 100%;
          }
          .or {
            width: 110px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #57a773;
            color: var(--white-no-blue);
            @media (max-width: 767px) {
              display: none;
            }
          }
          .select {
            position: relative;
          }
          .content {
            position: absolute;
            top: 80px;
            left: 0;
            width: calc(100%);
            opacity: 0;
            transform: translateY(-10px);
            pointer-events: none;
            transition: 0.6s;
            background: var(--white-bg);
            border-top: 2px solid #ababab;
            z-index: 99;
            padding-bottom: 20px;
            max-height: 300px;
            overflow: auto;
            p {
              margin-top: 10px;
              cursor: pointer;
              width: 100%;
              padding-left: 43px;
              padding-right: 43px;
              padding-top: 10px;
              padding-bottom: 10px;
              transition: 0.6s;
              @media (min-width: 1024px) {
                &:hover {
                  background-color: #e3b505;
                  color: white;
                }
              }
            }
            &.active {
              opacity: 1;
              transform: translateY(0px);
              pointer-events: all;
            }
          }
          .top-cont {
            padding-left: 26px;
            padding-right: 26px;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            background: var(--white-bg);
            @media (max-width: 1679px) {
              padding-left: 20px;
              padding-right: 20px;
            }
            p {
              opacity: 0.5;
              color: var(--bonus-txt);
              user-select: none;
            }
          }
        }
        .vue-map-container {
          width: 100%;
          height: 100%;
          transition: none;
          button {
            display: none;
          }
          .gmnoprint {
            display: none;
          }
        }
      }
    }
  }
}
</style>
